import { render, staticRenderFns } from "./rukuzuoye.vue?vue&type=template&id=6922ec24&scoped=true&"
import script from "./rukuzuoye.vue?vue&type=script&lang=js&"
export * from "./rukuzuoye.vue?vue&type=script&lang=js&"
import style0 from "./rukuzuoye.vue?vue&type=style&index=0&id=6922ec24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922ec24",
  null
  
)

export default component.exports